// Streamdown's default element renderers attach Tailwind utility classes to every element (e.g.
// `<blockquote class="my-4 border-l-4 ...">`).  There is no global "unstyled" switch, but custom
// component overrides fully replace the defaults *including* their built-in styles — so replace
// every styled element with its plain semantic equivalent and let the app's stylesheets own the
// look.  Only the code/mermaid block chrome keeps streamdown's classes (their renderers cannot be
// overridden without losing the shiki/mermaid pipeline) — those are restyled via Markdown.scss...
const plainElement = (Tag: any) => ({ node, children, ...props }: any) => <Tag {...props}>{children}</Tag>;

export const plainElements = Object.fromEntries(
    ["p", "ul", "ol", "li", "blockquote", "hr", "img", "sup", "sub", "section", "table", "thead", "tbody", "tr", "th", "td"]
        .map(tag => [tag, plainElement(tag)]));

// Parity overrides: streamdown renders bold as a styled <span> and inline code as a "pill" —
// restore the plain semantic elements the app's styling (and tenant CSS) expects...
export const plainStrong = ({ node, children, ...props }: any) => <strong {...props}>{children}</strong>;
export const plainInlineCode = ({ node, children, ...props }: any) => <code {...props}>{children}</code>;
